export default __webpack_public_path__ + "static/media/checkbox-black-checked.bf6c1336.svg";